








































import Vue, { VueConstructor } from 'vue';
import { mapActions, mapState } from 'vuex';
import { RoomState, Host } from '@/views/List/typings';
import { POSITION } from 'vue-toastification';
import { Logined, UserState } from '@/views/Home/typings';

interface AppbarLocalType {
	host: Host;
	logined: Logined;

	backwardView: () => void;
	homeMenuHandler: () => void;
	handleRightMenu: () => void;
	activeUploadMenuAction: () => void;
	resetAllChatsAction: () => void;
	underConstructionHandler: () => void;
	userInfoHandler: () => void;
}

export default (Vue as VueConstructor<Vue & AppbarLocalType>).extend({
	name: 'AppbarVue',

	computed: {
		...mapState('userReducer', {
			logined: (state) => (state as UserState).logined,
		}),
		...mapState('roomReducer', {
			host: (state) => (state as RoomState).host,
		}),

		viewTitle() {
			return this.$route.name;
		},
	},

	data: () => ({
		isTheme: false as boolean,
	}),

	methods: {
		...mapActions('chatReducer', ['resetAllChatsAction']),
		...mapActions('uploadReducer', ['activeUploadMenuAction']),

		backwardView() {
			try {
				switch (this.viewTitle) {
					case 'Home':
						this.$toast.warning(' First Page: Impossible to backward 🚫 ', {
							position: POSITION.TOP_CENTER,
						});
						throw new Error(' Error: Impossible to backward 🚫 ');
					case 'List':
						this.$router.push('/');
						break;
					case 'Room':
						this.$router.push('/list');
						break;

					default:
						break;
				}
			} catch (error) {
				console.error((error as Error).message);
			}
		},

		homeMenuHandler(e: MouseEvent | PointerEvent) {
			const selectedMenu = (e.currentTarget as HTMLDivElement).dataset.name;
			const root = document.querySelector(':root') as HTMLElement;

			switch (selectedMenu) {
				case 'deleteAll':
					this.resetAllChatsAction();

					// show noti
					this.$toast.error(' Chat History Deleted 🗑 ', {
						position: POSITION.TOP_CENTER,
					});

					console.log(
						'%c Chat History Deleted 🗑 ',
						`
						color: #e1306c;
						font-size: 1rem;
						font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
						`
					);
					break;
				case 'themeChange':
					this.isTheme = !this.isTheme;

					this.isTheme
						? root.style.setProperty('--primary', '#e1306c')
						: root.style.setProperty('--primary', '#3b5998');

					// show noti
					this.$toast.success(' Theme Changed 🎨  ', {
						position: POSITION.TOP_CENTER,
					});

					console.log(
						'%c Theme Changed 🎨 ',
						`
						color: #3b5998;
						font-size: 1rem;
						font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
						`
					);
					break;
			}
		},

		userInfoHandler() {
			this.$toast.info(` You are logined as ${this.logined.name} 👍🏻 `, {
				position: POSITION.TOP_CENTER,
			});

			console.log(
				`%c You are logined as ${this.logined.name} 👍🏻 `,
				`
				color: #f72;
				font-size: 1rem;
				font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
				`
			);
		},

		underConstructionHandler() {
			this.$toast.warning(` Under construction... 🔨 `, {
				position: POSITION.TOP_CENTER,
			});

			console.log(
				`%c Under construction... 🔨 `,
				`
				color: #b38;
				font-size: 1rem;
				font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
				`
			);
		},
	},
});
